<template>
  <JoszakiModal
    :open="showReportPerson"
    :title="$t('reportMate.header')"
    @close="close"
  >
    <template #body>
      <div>
        <h1 class="text-xl font-bold text-gray-800">
          {{ $t("reportMate.title") }}
        </h1>

        <h2 class="text-base font-bold text-gray-800 mt-4">
          {{ $t("reportMate.chooseOption") }}
        </h2>
        <JoszakiRadio
          v-model="reason"
          :validation-state="v$.reason"
          class="text-base ml-4"
          :options="[
            { value: 'underage', label: $t('reportMate.options.underage') },
            { value: 'notreal', label: $t('reportMate.options.notreal') },
            {
              value: 'wrongProfessions',
              label: $t('reportMate.options.wrongProfessions'),
            },
            { value: 'other', label: $t('reportMate.options.other') },
          ]"
        />
        <JoszakiTextArea
          v-if="reason === 'other'"
          v-model="message"
          :validation-state="v$.message"
        />
        <JoszakiInput
          v-model="email"
          :validation-state="v$.email"
          type="email"
          class="mt-8"
          :label="$t('reportMate.email')"
          @keyup="onEmailKeyup"
        />
      </div>
    </template>
    <template #footer>
      <JoszakiButton
        expanded
        type="success"
        :loading="loading"
        :disabled="loading"
        @click="submit"
      >
        {{ $t("reportMate.submit") }}
      </JoszakiButton>
    </template>
  </JoszakiModal>
</template>

<script>
import { useVuelidate } from "@vuelidate/core";
import { useProfessionalStore } from "~/stores/professional";

export default {
  setup() {
    return {
      professionalStore: useProfessionalStore(),
      v$: useVuelidate(),
    };
  },
  data() {
    return {
      email: "",
      reason: "",
      message: "",
      loading: false,
      showReportPerson: false,
    };
  },
  validations() {
    const { rules } = this.$validation;
    return {
      reason: {
        required: rules.required,
      },
      message: {
        requiredIf: rules.requiredIf(() => this.reason === "other"),
      },
      email: {
        required: rules.required,
        email: rules.email,
      },
    };
  },
  mounted() {
    this.$nuxt.$on("report-person", this.open);
  },
  beforeDestroy() {
    this.$nuxt.$off("report-person", this.open);
  },
  methods: {
    async submit() {
      const valid = await this.v$.$validate();
      if (!valid) {
        return;
      }
      this.loading = true;
      const reasonString =
        this.reason === "other"
          ? this.message
          : this.$t(`reportMate.options.${this.reason}`);
      const message = this.$t("reportMate.message", {
        email: this.email,
        reason: reasonString,
        mateUrl: `${this.$helpers.topDomain}${this.$route.fullPath}`,
      });
      try {
        await this.professionalStore.reportPerson(message);
        this.$joszaki.alert({
          message: this.$t("reportMate.success"),
          type: "success",
        });
        this.close();
      } catch (err) {
        if (typeof err === "string") {
          this.$joszaki.toast({
            message: err,
            type: "danger",
          });
        } else {
          this.$sentry.captureException(err, {
            tags: {
              profile: "report_mate",
            },
          });
        }
      } finally {
        this.loading = false;
      }
    },
    onEmailKeyup(event) {
      if (event.key === "Enter") {
        this.submit();
      }
    },
    open() {
      this.showReportPerson = true;
      this.email = "";
      this.reason = "";
      this.message = "";
      this.v$.$reset();
    },
    close() {
      this.showReportPerson = false;
    },
  },
};
</script>
